export interface WorkItem {
  id: string;
  title: string;
  cover: string;
  hero: string;
  category: string;
  region: string;
  year: number;
  rating: number;
  episodes: number;
  synopsis: string;
  tags: string[];
  guide: string;
}

export const workCategories: string[] = ["冒险", "恋爱", "科幻", "奇幻", "治愈", "热血", "日常", "古风"];
export const workRegions: string[] = ["日本", "中国", "欧美"];
export const workYears: number[] = [2025, 2024, 2023, 2022];

export const worksList: WorkItem[] = [
  {
    id: "starsea-route",
    title: "星海航路",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20young%20spaceship%20pilot%20in%20a%20flight%20suit%20holding%20a%20helmet%2C%20glowing%20starship%20behind%20under%20a%20deep%20blue%20starfield%2C%20vibrant%20orange%20accents%2C%20cel%20shaded%20anime%20art%20style%2C%20cinematic%20composition%2C%20clean%20background&width=600&height=900&seq=work-poster-starsea&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20wide%20key%20visual%20of%20a%20flotilla%20of%20starships%20traveling%20through%20a%20colorful%20nebula%2C%20deep%20blue%20space%20with%20glowing%20orange%20engines%2C%20cel%20shaded%20anime%20art%20style%2C%20epic%20cinematic%20composition%2C%20detailed%20background&width=1600&height=900&seq=work-hero-starsea&orientation=landscape",
    category: "科幻",
    region: "日本",
    year: 2024,
    rating: 9.2,
    episodes: 24,
    synopsis:
      "在被星辰割裂的宇宙中，少年驾驶着祖辈留下的老旧星舰，踏上一场横跨星海的旅程，去追寻失落航路背后的真相与自己的归宿。",
    tags: ["太空", "成长", "群像"],
    guide: "本作为连续剧集，建议从头按顺序观看，第一季共 24 集。每集约 24 分钟，适合连续追看。",
  },
  {
    id: "southwind-tale",
    title: "南风物语",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20girl%20in%20a%20summer%20dress%20standing%20by%20the%20seaside%20at%20sunset%2C%20warm%20golden%20sky%20and%20gentle%20waves%2C%20soft%20mint%20and%20amber%20tones%2C%20cel%20shaded%20anime%20art%20style%2C%20nostalgic%20composition%2C%20clean%20background&width=600&height=900&seq=work-poster-southwind&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20wide%20key%20visual%20of%20a%20quiet%20seaside%20town%20at%20golden%20hour%2C%20two%20friends%20walking%20along%20train%20tracks%20by%20the%20sea%2C%20warm%20amber%20and%20mint%20tones%2C%20cel%20shaded%20anime%20art%20style%2C%20cinematic%20wide%20shot&width=1600&height=900&seq=work-hero-southwind&orientation=landscape",
    category: "治愈",
    region: "日本",
    year: 2023,
    rating: 8.8,
    episodes: 12,
    synopsis:
      "海街小城的一个夏天，少女在帮外婆打理旧杂货店的日子里，重新遇见了童年时约定好要一起看海的朋友。",
    tags: ["夏日", "友情", "成长"],
    guide: "共 12 集，为单元剧形式，任意集数切入都能获得完整体验，推荐按顺序观看以获得情感递进。",
  },
  {
    id: "sword-and-traveler",
    title: "剑与旅人",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20lone%20swordsman%20in%20a%20flowing%20cloak%20gripping%20a%20longsword%20under%20a%20dramatic%20orange%20sky%2C%20fantasy%20kingdom%20silhouette%20behind%2C%20cel%20shaded%20anime%20art%20style%2C%20epic%20composition%2C%20clean%20background&width=600&height=900&seq=work-poster-sword&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20wide%20key%20visual%20of%20a%20vast%20fantasy%20kingdom%20with%20towering%20castles%20at%20dusk%2C%20a%20traveler%20walking%20a%20winding%20road%2C%20dramatic%20orange%20and%20teal%20sky%2C%20cel%20shaded%20anime%20art%20style%2C%20epic%20cinematic%20composition&width=1600&height=900&seq=work-hero-sword&orientation=landscape",
    category: "奇幻",
    region: "日本",
    year: 2025,
    rating: 9.0,
    episodes: 0,
    synopsis:
      "王国边境的旅人背着旧剑，走过一座座城镇，替人解决难题，也一步步逼近自己不愿面对的过去。",
    tags: ["剑客", "旅途", "群像"],
    guide: "动画尚未开播，具体时长与集数待官方公布。可先阅读原作漫画了解世界观。",
  },
  {
    id: "moonlight-cafe",
    title: "月下咖啡厅",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20barista%20girl%20smiling%20behind%20a%20cozy%20cafe%20counter%20at%20night%2C%20warm%20lamps%20and%20moonlight%20through%20the%20window%2C%20amber%20and%20teal%20accents%2C%20cel%20shaded%20anime%20art%20style%2C%20clean%20background&width=600&height=900&seq=work-poster-mooncafe&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20wide%20key%20visual%20of%20a%20cozy%20night%20cafe%20street%20with%20glowing%20windows%20and%20a%20moon%20above%2C%20warm%20amber%20lamps%20and%20cool%20teal%20night%20tones%2C%20cel%20shaded%20anime%20art%20style%2C%20detailed%20background&width=1600&height=900&seq=work-hero-mooncafe&orientation=landscape",
    category: "恋爱",
    region: "日本",
    year: 2024,
    rating: 8.5,
    episodes: 13,
    synopsis:
      "只在夜晚营业的咖啡厅里，来客带来各自的烦恼与故事，而负责冲煮咖啡的少女，也在这份烟火气里慢慢走近他人。",
    tags: ["日常", "治愈", "群像"],
    guide: "共 13 集，单元剧结构，适合睡前放松观看，无需连续追看。",
  },
  {
    id: "mountain-river",
    title: "山河引",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20an%20ancient%20Chinese%20young%20swordsman%20in%20traditional%20robes%20standing%20before%20misty%20mountains%2C%20ink%20wash%20blended%20with%20anime%20art%2C%20teal%20green%20and%20gold%20accents%2C%20elegant%20composition%2C%20clean%20background&width=600&height=900&seq=work-poster-shanhe&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20wide%20key%20visual%20of%20a%20vast%20ancient%20mountain%20landscape%20with%20floating%20pavilions%20and%20misty%20peaks%2C%20teal%20green%20and%20warm%20gold%20light%2C%20ink%20wash%20blended%20with%20anime%20art%2C%20cinematic%20wide%20composition&width=1600&height=900&seq=work-hero-shanhe&orientation=landscape",
    category: "古风",
    region: "中国",
    year: 2025,
    rating: 9.1,
    episodes: 16,
    synopsis:
      "乱世之中，一位少年为查明师门变故的真相，循着山河的脉络一路前行，卷入了一场关乎天下的棋局。",
    tags: ["水墨", "江湖", "成长"],
    guide: "共 16 集，剧情连贯，建议按顺序观看。每集约 22 分钟。",
  },
  {
    id: "mecha-city",
    title: "机械都市 2099",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20giant%20mecha%20robot%20posing%20in%20a%20futuristic%20neon%20city%2C%20glowing%20orange%20eyes%20and%20teal%20neon%20signs%2C%20cel%20shaded%20mecha%20anime%20art%20style%2C%20dramatic%20low%20angle%2C%20clean%20background&width=600&height=900&seq=work-poster-mecha&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20wide%20key%20visual%20of%20a%20futuristic%20night%20city%20with%20towering%20neon%20buildings%20and%20a%20giant%20mecha%20silhouette%20between%20them%2C%20orange%20and%20teal%20neon%20glow%2C%20cel%20shaded%20mecha%20anime%20art%20style%2C%20cinematic%20composition&width=1600&height=900&seq=work-hero-mecha&orientation=landscape",
    category: "科幻",
    region: "日本",
    year: 2025,
    rating: 8.7,
    episodes: 22,
    synopsis:
      "在被机械与数据统治的未来都市，少年机师驾驶着旧型号机体，试图在秩序与自由之间找到属于自己的答案。",
    tags: ["机甲", "朋克", "热血"],
    guide: "共 22 集，剧情紧凑，建议按顺序观看，避免跳过战斗与设定回。",
  },
  {
    id: "spirit-boy",
    title: "灵域少年",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20spirited%20teenage%20boy%20with%20glowing%20spirit%20energy%20swirling%20around%20his%20fist%2C%20determined%20expression%2C%20orange%20and%20blue%20energy%20effects%2C%20cel%20shaded%20anime%20art%20style%2C%20dynamic%20action%20pose%2C%20clean%20background&width=600&height=900&seq=work-poster-spirit&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20wide%20key%20visual%20of%20an%20energetic%20battle%20between%20spirit%20warriors%20with%20glowing%20auras%20in%20a%20dramatic%20arena%2C%20orange%20and%20teal%20energy%20bursts%2C%20cel%20shaded%20anime%20art%20style%2C%20epic%20cinematic%20composition&width=1600&height=900&seq=work-hero-spirit&orientation=landscape",
    category: "热血",
    region: "中国",
    year: 2023,
    rating: 8.4,
    episodes: 26,
    synopsis:
      "天生拥有灵力却迟迟无法觉醒的少年，在一次次磨砺中结识伙伴，逐步成长为守护一方安宁的灵域战士。",
    tags: ["热血", "成长", "伙伴"],
    guide: "共 26 集，前期节奏较慢，建议坚持看到第 6 集后进入主线。",
  },
  {
    id: "flower-tale",
    title: "花间绮谭",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20an%20elegant%20ancient%20Chinese%20lady%20in%20flowing%20robes%20amid%20blooming%20flowers%2C%20soft%20pink%20and%20gold%20tones%2C%20delicate%20ink%20wash%20blended%20with%20anime%20art%2C%20romantic%20composition%2C%20clean%20background&width=600&height=900&seq=work-poster-flower&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20wide%20key%20visual%20of%20an%20ancient%20garden%20with%20blooming%20flower%20trees%20and%20a%20pavilion%2C%20soft%20warm%20pink%20and%20gold%20light%2C%20ink%20wash%20blended%20with%20anime%20art%2C%20dreamy%20cinematic%20composition&width=1600&height=900&seq=work-hero-flower&orientation=landscape",
    category: "恋爱",
    region: "中国",
    year: 2024,
    rating: 8.6,
    episodes: 16,
    synopsis:
      "花匠之女与行商少年在一场花会中偶然相识，一段跨越身份与命运的缘分在两座城池之间悄然生长。",
    tags: ["古风", "情缘", "唯美"],
    guide: "共 16 集，情感线细腻，建议按顺序观看，配合番外篇食用体验更佳。",
  },
  {
    id: "aurora-train",
    title: "极光列车",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20mysterious%20night%20train%20with%20glowing%20windows%20traveling%20through%20a%20snowy%20pine%20forest%20under%20aurora%20skies%2C%20teal%20and%20violet%20light%2C%20cel%20shaded%20anime%20art%20style%2C%20mysterious%20composition%2C%20clean%20background&width=600&height=900&seq=work-poster-aurora&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20wide%20key%20visual%20of%20a%20lone%20train%20crossing%20an%20endless%20snowfield%20under%20a%20vast%20green%20aurora%2C%20teal%20and%20violet%20night%20tones%2C%20cel%20shaded%20anime%20art%20style%2C%20atmospheric%20cinematic%20composition&width=1600&height=900&seq=work-hero-aurora&orientation=landscape",
    category: "奇幻",
    region: "日本",
    year: 2022,
    rating: 8.9,
    episodes: 12,
    synopsis:
      "一列只在深夜出现的列车，载着各怀心事的乘客穿越雪原。而登上列车的少年，只为找到一个早已消失的答案。",
    tags: ["悬疑", "奇幻", "氛围"],
    guide: "共 12 集，叙事带有悬疑色彩，建议按顺序观看，避免剧透。",
  },
  {
    id: "sweet-magic-house",
    title: "甜点魔法屋",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20cheerful%20girl%20baker%20holding%20a%20colorful%20cake%20in%20a%20charming%20bakery%2C%20warm%20cream%20and%20peach%20tones%2C%20cel%20shaded%20anime%20art%20style%2C%20cozy%20composition%2C%20clean%20background&width=600&height=900&seq=work-poster-sweet&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20wide%20key%20visual%20of%20a%20cozy%20bakery%20street%20with%20colorful%20cakes%20in%20the%20window%20and%20warm%20afternoon%20light%2C%20cream%20and%20peach%20tones%2C%20cel%20shaded%20anime%20art%20style%2C%20charming%20cinematic%20composition&width=1600&height=900&seq=work-hero-sweet&orientation=landscape",
    category: "日常",
    region: "日本",
    year: 2024,
    rating: 8.2,
    episodes: 12,
    synopsis:
      "一家藏在巷子深处的甜点店，据说吃了这里的点心就会想起最珍贵的回忆。少女店主用甜点抚慰着每位到访的客人。",
    tags: ["治愈", "美食", "温馨"],
    guide: "共 12 集，单元剧结构，随意集数观看皆可，适合放松心情。",
  },
  {
    id: "wilderness-poem",
    title: "荒野之诗",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20lone%20traveler%20on%20horseback%20crossing%20a%20vast%20western%20desert%20at%20sunset%2C%20dramatic%20orange%20sky%20and%20long%20shadows%2C%20cel%20shaded%20anime%20art%20style%2C%20epic%20composition%2C%20clean%20background&width=600&height=900&seq=work-poster-wilderness&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20wide%20key%20visual%20of%20an%20endless%20western%20canyon%20landscape%20at%20golden%20hour%20with%20a%20lone%20rider%20in%20the%20distance%2C%20warm%20orange%20and%20dust%20tones%2C%20cel%20shaded%20anime%20art%20style%2C%20epic%20cinematic%20composition&width=1600&height=900&seq=work-hero-wilderness&orientation=landscape",
    category: "冒险",
    region: "欧美",
    year: 2023,
    rating: 8.3,
    episodes: 10,
    synopsis:
      "在荒凉的西部边陲，一位失去一切的旅人骑着老马穿过峡谷与小镇，用一段段相遇书写属于自己的诗篇。",
    tags: ["西部", "旅途", "孤独"],
    guide: "共 10 集，公路剧结构，按顺序观看更能感受旅途的连贯感。",
  },
  {
    id: "future-equation",
    title: "未来方程式",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20poster%20illustration%20of%20a%20determined%20young%20athlete%20in%20a%20high%20tech%20racing%20suit%20standing%20on%20a%20futuristic%20track%2C%20glowing%20teal%20lines%20and%20orange%20accents%2C%20cel%20shaded%20anime%20art%20style%2C%20dynamic%20composition%2C%20clean%20background&width=600&height=900&seq=work-poster-future&orientation=portrait",
    hero:
      "https://readdy.ai/api/search-image?query=Stylized%20anime%20wide%20key%20visual%20of%20a%20futuristic%20high%20tech%20racing%20arena%20with%20glowing%20teal%20tracks%20and%20cheering%20crowds%2C%20orange%20energy%20streaks%2C%20cel%20shaded%20anime%20art%20style%2C%20high%20energy%20cinematic%20composition&width=1600&height=900&seq=work-hero-future&orientation=landscape",
    category: "科幻",
    region: "日本",
    year: 2025,
    rating: 8.0,
    episodes: 24,
    synopsis:
      "在科技竞速成为主流运动的未来，一支濒临解散的少年车队，凭借对速度的信念，向着最高殿堂发起挑战。",
    tags: ["运动", "竞技", "热血"],
    guide: "共 24 集，比赛节奏明快，建议按顺序观看，比赛篇章堪称亮点。",
  },
];